export default __webpack_public_path__ + "static/media/bazzle2.ff4a14f6.png";